import { useState } from 'react';
import { Button, Modal } from '@safetyhub/ui';
import { objectParticleOf } from '@safetyhub/shared';

interface Props {
  itemName: string;
  hasChildren: boolean;
  onConfirm: () => Promise<void>;
  onClose: () => void;
}

export function ProcessTypeDeleteModal({ itemName, hasChildren, onConfirm, onClose }: Props) {
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleConfirm = async () => {
    setSubmitting(true);
    setError('');
    try {
      await onConfirm();
      onClose();
    } catch (err) {
      setError(err instanceof Error ? err.message : '삭제에 실패했습니다.');
    } finally {
      setSubmitting(false);
    }
  };

  // 부모가 열 때만 마운트하므로 open은 늘 true다. 삭제 중에는 닫는 길(오버레이·Esc·✕) 전부를 막는다 —
  // 종전에도 오버레이 클릭이 `!submitting`일 때만 닫았다.
  return (
    <Modal
      open
      onClose={onClose}
      title="공종/공정 삭제"
      size="sm"
      closeOnOverlay={!submitting}
      closeOnEsc={!submitting}
      showCloseButton={!submitting}
      closeLocked={submitting}
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={submitting}>
            취소
          </Button>
          <Button variant="danger" onClick={handleConfirm} disabled={submitting}>
            {submitting ? '삭제 중...' : '삭제'}
          </Button>
        </>
      }
    >
      <p className="text-sm text-ink-600 mb-1">
        <strong>{itemName}</strong>{objectParticleOf(itemName)} 삭제하시겠습니까?
      </p>
      {hasChildren && (
        <p className="text-sm text-orange-600 mb-3">하위 공정도 함께 삭제됩니다.</p>
      )}
      {error && <p className="text-sm text-red-600 mb-3">{error}</p>}
    </Modal>
  );
}
